/* Architectural landing pages: FAQ accordion + enquiry form (posts to form.mozaico.com like the design-services form). */
(function () {
  var root = document.querySelector('[data-mzl]');
  if (!root) return;

  // FAQ: one open at a time, clicking the open one closes it
  var faq = root.querySelector('[data-mzl-faq]');
  if (faq) {
    faq.addEventListener('click', function (e) {
      var btn = e.target.closest('.mzl-faq__q');
      if (!btn) return;
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('is-open');
      faq.querySelectorAll('.mzl-faq__item').forEach(function (it) {
        it.classList.remove('is-open');
        it.querySelector('.mzl-faq__q').setAttribute('aria-expanded', 'false');
        it.querySelector('.mzl-faq__a').hidden = true;
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        item.querySelector('.mzl-faq__a').hidden = false;
      }
    });
  }

  // Spec PDF downloads, for GTM
  root.querySelectorAll('[data-mzl-pdf]').forEach(function (a) {
    a.addEventListener('click', function () {
      (window.dataLayer = window.dataLayer || []).push({ event: 'landing_spec_download', landing_page: location.pathname });
    });
  });

  var form = root.querySelector('[data-mzl-form]');
  if (!form) return;
  var msg = form.querySelector('[data-mzl-msg]');
  var submit = form.querySelector('[data-mzl-submit]');
  var fileInput = form.querySelector('input[type=file]');
  var fileLabel = form.querySelector('[data-mzl-filename]');
  var drop = form.querySelector('.mzl-drop');
  var defaultFileText = fileLabel.textContent;
  var MAX = 5 * 1024 * 1024; // form.mozaico.com limit
  var API = (typeof apiUrl !== 'undefined' ? apiUrl : 'https://form.mozaico.com') + '/form/inquire-about-design';

  function say(text, isError) {
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
  }
  function showFile() {
    var f = fileInput.files[0];
    fileLabel.textContent = f ? f.name : defaultFileText;
  }
  fileInput.addEventListener('change', showFile);
  ['dragenter', 'dragover'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
  });
  ['dragleave', 'drop'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
  });
  drop.addEventListener('drop', function (e) {
    if (e.dataTransfer && e.dataTransfer.files.length) { fileInput.files = e.dataTransfer.files; showFile(); }
  });

  var el = function (n) { return form.elements[n]; };
  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    var name = el('name').value.trim();
    var email = el('email').value.trim();
    var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    el('name').closest('.mzl-field').classList.toggle('is-invalid', !name);
    el('email').closest('.mzl-field').classList.toggle('is-invalid', !okEmail);
    if (!name || !okEmail) { say('Please add your name and a valid email.', true); return; }
    var file = fileInput.files[0];
    if (file && file.size > MAX) { say('That file is over 5 MB. Please send a smaller one.', true); return; }

    var parts = name.split(/\s+/);
    var role = (form.querySelector('input[name=role]:checked') || {}).value || '';
    var fd = new FormData();
    fd.append('firstName', parts.shift());
    fd.append('lastName', parts.join(' '));
    fd.append('email', email);
    fd.append('phoneNumber', el('phoneNumber').value.trim());
    fd.append('message', 'I am a: ' + role + '\nSize: ' + (el('size').value.trim() || '-') + '\n\n' + el('details').value.trim());
    fd.append('page', el('page').value);
    if (file) fd.append('file', file, file.name);
    try {
      var g = localStorage.getItem('google_click_id');
      if (g && !fd.has('gclid_field')) fd.append('gclid_field', g);
    } catch (err) {}

    submit.disabled = true;
    say('Sending…');
    try {
      var token = typeof reCaptchaToken === 'function' ? await reCaptchaToken() : '';
      fd.append('token', token);
      var res = await fetch(API, { method: 'POST', body: fd });
      var json = await res.json();
      if (json && json.reCAPTCHASuccess === false) throw new Error(json.message || 'reCAPTCHA failed');
      if (String(json && json.msg) !== '200') throw new Error('rejected');
      form.reset();
      showFile();
      submit.textContent = 'Request received ✓';
      say("Thank you! We'll reply within one business day.");
      (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', form_name: 'landing_page_sketch', landing_page: location.pathname, lead_role: role });
      try { if (window.oaiq) window.oaiq('measure', 'lead_created', { type: 'customer_action' }); } catch (err) {}
    } catch (err) {
      submit.disabled = false;
      say('Something went wrong. Please try again, or email sales@mozaico.com.', true);
    }
  });
})();
